import { Button as _Button, Link as _Link, AppBar, Grid, styled } from '@mui/material'
import * as colors from 'utils/color'

export const drawerWidth = 256

export const Container = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
}))

export const AppContainer = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}))

export const Main = styled('main')(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(3, 2),
}))

export const LinksGrid = styled(Grid)(({ theme }) => ({
  maxWidth: 500,
  margin: '0 auto',
  marginBottom: theme.spacing(5),
}))

export const LinkContainer = styled(Grid)(() => ({
  textAlign: 'center',
}))

export const Link = styled(_Link)(({ theme }) => ({
  color: theme.palette.grey[700],
})) as typeof _Link

export const Button = styled(_Button)(({ theme }) => ({
  width: 200,
  height: 50,
  marginBottom: theme.spacing(3),
  backgroundColor: colors.red,
  color: colors.white,
  fontWeight: 'bold',
}))

///////////////////////////////////
// Header
///////////////////////////////////

export const HeaderContainer = styled(AppBar)(({ theme }) => ({
  padding: theme.spacing(1, 0),
  backgroundColor: colors.red,
}))

export const HeaderLogo = styled('img')(({ theme }) => ({
  height: 50,
  [theme.breakpoints.down('md')]: {
    width: 200,
    height: 'auto',
    marginLeft: 'calc((100% - 200px) / 2)',
  },
}))
